// Dependencies
import Cookies from "js-cookie";
import { useEffect } from "react";

/**
 * Populates the XSRF/CSRF token in the global window object.
 */
const useGlobalXsrfToken = () => {
	useEffect(() => {
		const token = Cookies.get("_xsrf");

		if (token) {
			window.xsrf_val = token;
		}
	}, []);
};

/**
 * Hooks to setup the app.
 */
export const AppSetup = () => {
	useGlobalXsrfToken();
	return null;
};
